const RICOS_VERSION = "10.106.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
